<template>
  <div>
    <Subheader title="Needs Further Review" />

    <div class="app-content-column">
      <div class="card">
        <h5>Project needs review</h5>
        <p class="bold-text">Once you mark this project as needing review, you will need to:</p>
        <ul class="verification-bullets">
          <li>Contact the "Maker" to let them know you are reviewing it</li>
          <li>Validate that all their information is correct</li>
          <li>
            Work with the Maker to fix or improve their project description, to give it the best
            chance for success
          </li>
        </ul>
      </div>

      <div class="card">
        <h5>About Maker</h5>
        <p>Name: {{ maker.fullName ? maker.fullName : '' }}</p>
        <p>Email: {{ maker.email ? maker.email : '' }}</p>
        <p>Phone Number: {{ maker.phoneNumber ? maker.phoneNumber : '' }}</p>
        <p>Bio: {{ maker.description ? maker.description : '' }}</p>
      </div>

      <div class="card">
        <h5>Feedback (will be delievered to Maker)</h5>
        <textarea v-model="staffNotes" class="textarea" name cols="30" rows="10"></textarea>
        <div class="btn-wrapper is-centered">
          <button class="large-button" @click="submitNotes">Submit Feedback</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'
import Auth from '@/services/auth'
import Project from '@/services/projects'
import User from '@/services/users'
import store from '@/store'

export default {
  name: 'AssignmentsNeedsFurtherReview',
  components: {
    Subheader,
  },
  data() {
    return {
      projectId: '',
      maker: {},
      staffNotes: '',
    }
  },
  created() {
    this.projectId = this.$route.params.projectId
    this.refreshData()
  },
  methods: {
    refreshData() {
      Project.api.get(this.projectId).then(data => {
        User.api.getUser(data.maker).then(data => {
          this.maker = data
        })
      })
    },
    submitNotes() {
      const reportURL = `projects/${this.projectId}/add-notes/`
      const authHeader = Auth.getAuthorizationHeader()
      const data = {
        activator_notes: this.staffNotes,
      }
      const options = {
        headers: {
          ...authHeader,
        },
      }
      const reportPromise = store.getters.apiClient.post(reportURL, data, options)
      reportPromise.then(() => {
        this.$Alert.alert({
          type: 'success',
          message: `<h2>Feedback Sent. Thanks!</h2>`,
          timeout: 3000,
        })
        this.$router.push({ name: 'AssignmentsOverview' })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins/cards';
@import '../styles/mixins/containers';
@import '../styles/mixins/buttons';
@import '../styles/forms';
@import '../styles/layout';

.card {
  @include card-w-borders();
  align-items: center;
  margin-top: 1.25rem;
}

.needs-review-btn {
  @include large-button-inverted();
}

.btn-container {
  justify-content: center;
  margin-top: 20px;
  width: inherit;
  text-align: center;
}

.verification-bullets {
  margin-left: 2rem;
}

li {
  margin-bottom: 1rem;
}

.large-button {
  @media only screen and (max-width: $mobile-smallest-width) {
    width: 15rem;
  }
}
</style>
